import clsx from "clsx";
import type { ReactNode } from "react";

export type PageTab = {
  active?: boolean;
  className?: string;
  href?: string;
  key: string;
  label: ReactNode;
  onClick?: () => void;
};

export const PageTabs = ({
  ariaLabel,
  className,
  tabs,
}: {
  ariaLabel: string;
  className?: string;
  tabs: PageTab[];
}) => {
  if (tabs.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label={ariaLabel}
      className={clsx("mobile-page-tabs", className)}
      data-mobile-page-tabs={tabs.length}
    >
      <div className="mobile-page-tablist">
        {tabs.map((tab) => {
          const className = clsx(
            "mobile-page-tab",
            tab.className,
            tab.active && "mobile-page-tab-active",
          );

          if (tab.href === undefined) {
            return (
              <button
                aria-pressed={tab.active}
                className={className}
                data-mobile-page-tab-key={tab.key}
                key={tab.key}
                onClick={tab.onClick}
                type="button"
              >
                <span className="mobile-page-tab-label">{tab.label}</span>
              </button>
            );
          }

          return (
            <a
              aria-current={tab.active ? "page" : undefined}
              className={className}
              data-mobile-page-tab-key={tab.key}
              href={tab.href}
              key={tab.key}
              onClick={tab.onClick}
            >
              <span className="mobile-page-tab-label">{tab.label}</span>
            </a>
          );
        })}
      </div>
    </nav>
  );
};

export default PageTabs;
